var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{staticStyle:{"background-color":"#EFF1F5"}}),_c('Banner'),_c('IndexOffers',{attrs:{"router":"this.$router"}}),_c('HowItWorks'),_c('WhyUs'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }